<template>
  <div>
    <!-- breadcrumb -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- search -->
    <el-form :inline="true" :model="formInline" class="user-search" ref="searchForm">
      <el-form-item label="查询：">
        <el-input size="small" v-model="formInline.username" placeholder="用户名" maxlength="32" clearable style="width: 160px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh" @click="resetSearch()">重置</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="popWin('sysUserInsert')">新增</el-button>
      </el-form-item>
    </el-form>

    <!--list-->
    <el-table size="small" ref="ids" @sort-change="getSortPageData" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="loading" style="width: 100%;">
      <el-table-column prop="username" label="用户名" width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="adminFlag" label="是否管理员" width="90" align="center">
        <template slot-scope="scope">
          <span :style="{ color: scope.row.adminFlag ? '#409EFF' : '' }">{{ scope.row.adminFlag ? '是' : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="200" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
          <i v-if="scope.row.username !== 'admin'" class="el-icon-edit remark-edit-icon" @click="showRemarkDialog(scope.row)"></i>
        </template>
      </el-table-column>
      <el-table-column align="left" label="操作" min-width="150">
        <template slot-scope="scope">
          <template v-if="scope.row.username !== 'admin'">
            <el-button type="text" size="mini" icon="el-icon-key" @click="resetPassword(scope.row)">重置密码</el-button>
            <el-button type="text" size="mini" icon="el-icon-delete" style="color: #F56C6C;" @click="deleteSysUser(scope.row.username)">删除</el-button>
          </template>
          <span v-else>系统管理员不可变更</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- page -->
    <Pagination v-bind:child-msg="pageParam" @callback_getPageData="callback_getPageData"></Pagination>

    <!-- 编辑备注对话框 -->
    <el-dialog title="编辑备注" :visible.sync="remarkDialogVisible" width="400px">
      <el-form :model="remarkForm" ref="remarkForm" label-width="80px">
        <el-form-item label="用户名">
          <el-input v-model="remarkForm.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="remarkForm.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="remarkDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitRemark">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 子组件 -->
    <sysUserInsert @callback="getPageData" ref="sysUserInsert"></sysUserInsert>
  </div>
</template>

<script>
import { sysUserPage, sysUserDelete, changePassword, sysUserChangeRemark } from '../../api/SysUser'
import qs from 'qs';
import Pagination from '../../components/Pagination'
import { loadToken } from '../../utils/util'
import sysUserInsert from './sysUserInsert'

export default {
  data() {
    return {
      loading: false,
      submitLoading: false,
      formInline: {
        current: 1,
        size: 10,
        username: undefined,
        token: loadToken(),
        orders: [],
      },
      listData: [], //分页数据
      // page param
      pageParam: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 编辑备注对话框
      remarkDialogVisible: false,
      remarkForm: {
        username: '',
        remark: ''
      }
    }
  },
  components: {
    Pagination,
    sysUserInsert,
  },

  created() {
    // 加载用户缓存
    this.userEntity = JSON.parse(localStorage.getItem('userEntity'));
    // 分页数据
    this.getPageData()
  },
  methods: {
    // 重置密码
    resetPassword(row) {
      this.$confirm('确定将用户[' + row.username + ']的密码重置为"123456"吗？', '重置密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changePassword({ username: row.username, password: '123456' })
          .then(res => {
            this.$message({ type: 'success', message: '密码已重置为123456' });
          })
          .catch(err => {
            this.$message({ type: 'error', message: '重置密码失败' });
            console.error(err);
          });
      }).catch(() => {});
    },

    // 显示编辑备注对话框
    showRemarkDialog(row) {
      this.remarkForm = {
        username: row.username,
        remark: row.remark || ''
      }
      this.remarkDialogVisible = true
    },

    // 提交备注修改
    submitRemark() {
      this.submitLoading = true
      sysUserChangeRemark(this.remarkForm)
        .then(res => {
          this.submitLoading = false
          this.$message({ type: 'success', message: '修改成功' })
          this.remarkDialogVisible = false
          this.getPageData()
        })
        .catch(err => {
          this.submitLoading = false
          this.$message({ type: 'error', message: '修改失败' })
          console.error(err)
        })
    },

    // page-1: page
    getPageData(parameter) {
      this.loading = true
      if (!parameter){
        parameter = this.formInline;
      }
      sysUserPage(parameter)
        .then(res => {
          this.loading = false;
          this.listData = res.data.records
          this.pageParam.currentPage = res.data.current;
          this.pageParam.pageSize = res.data.size
          this.pageParam.total = res.data.total
        })
        .catch(err => {
          this.loading = false;
          console.error('获取用户数据失败:', err);
          this.$message({
            type: 'error',
            message: '获取用户数据失败，请检查网络连接或稍后重试'
          });
        })
    },

    // page-2: callBack
    callback_getPageData(parm) {
      this.formInline.current = parm.currentPage
      this.formInline.size = parm.pageSize
      this.getPageData()
    },

    // page-3: page && sort
    getSortPageData(column){
      if (column.order != null){
        let sortProp = column.prop.replace(/([A-Z])/g, "_$1").toLowerCase();
        let orderBy = {"column": sortProp, "asc": column.order == 'ascending'};
        this.formInline.orders[0] = orderBy;
      } else {
        this.formInline.orders = [];
      }
      this.getPageData();
    },

    // search-1
    search() {
      this.getPageData()
    },

    // search-2
    resetSearch() {
      this.formInline.username = undefined
    },

    // 弹窗
    popWin(windownName, data) {
      if (this.$refs[windownName]){
        this.$refs[windownName].show(data);
      }
    },

    // 删除用户
    deleteSysUser(username) {
      let _this = this;
      this.$confirm('是否删除用户['+ username +']?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sysUserDelete({"idList": [username]})
          .then(res => {
            this.$message({type: 'success', message: '删除成功'})
            _this.getPageData();
          })
      }).catch(() => {
        this.$message({type: 'info', message: '取消删除'})
      })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.user-search .el-input--small {
    width: 180px!important;
}

.el-button--text {
  padding: 0 5px!important;
}

.remark-edit-icon {
  margin-left: 8px;
  color: #409EFF;
  cursor: pointer;
}

.remark-edit-icon:hover {
  color: #66b1ff;
}
</style>



// WEBPACK FOOTER //
// src/views/sysUser/sysUser.vue